<!--
 - @author: linwen linwen@fjxhx.com.
 - @createDate: 2020-09-08 14:13.
 - @file: 地图底部toolbar.
 - @copyRight © 2020年 新和兴.All rights reserved.
-->
<template>
  <div class="tool">
    <div class="tool-bar" v-if="groupList.length > 0">
<!--      <div class="tool-bar-item map-center" @click="$emit('mapCenter')">-->
<!--        <img src="../../assets/images/marker/icon-map-center.png" width="24px" alt="">-->
<!--        <div>中心定位</div>-->
<!--      </div>-->
      <!-- content -->
      <div class="tool-bar-wrapper">
        <el-carousel
          :autoplay="false"
          :indicator-position="groupList.length>1?'outside':'none'"
          :arrow="groupList.length>1?'hover':'never'"
        >
          <el-carousel-item
            v-for="(item, index) in groupList"
            :key="index"
          >
            <ul class="carousel-ul">
              <li
                class="carousel-li"
                v-for="(group, i) in item"
                :key="group.anchorTypeId"
                :class="[!group.isSelect ? 'active' : '']"
                @click="showGroup(i, group.anchorTypeId)"
              >
                <img class="anchor-icon" :src="imgUrl + group.anchorIconId" :class="[!group.isSelect ? 'img-active':'']" v-if="group.anchorIconId"/>
                <i class="iconfont iconshop" :style="{fontSize: '28px'}" v-else></i>
                <div class="text">{{group.anchorTypeName}}</div>
              </li>
            </ul>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
    <div class="tool-add" v-if="groupList.length === 0">
      <i class="iconfont iconjiahao"></i>
    </div>
  </div>
</template>

<script>
// import BScroll from 'better-scroll'
export default {
  name: 'mapToolBar',
  data() {
    return {
      imgUrl: this.$store.getters.fileApi,
      scroll: null
    }
  },
  props: {
    groupList: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    /**
     * @description: 选择分组
     * @author: linwen linwen@fjxhx.com
     * @createDate: 2020-09-08 14:45
     * @param: 选择分组
     */
    showGroup(i, anchorTypeId) {
      this.$emit('selectGroup', i, anchorTypeId)
    }
  }
}
</script>

<style scoped lang="less">
@import '../../assets/less/iconfont.css';

.tool {
  user-select: none;
  position: absolute;
  bottom: 10px;
  left: 50%;
  z-index: 10;
  transform: translateX(-50%);

  &-bar {
    height: 66px;
    border-radius: 50px;
    padding: 0 10px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    font-size: 14px;

    .active {
      color: #858787;
    }
    .img-active {
      /*grayscale(val):val值越大灰度就越深*/
      -webkit-filter: grayscale(100%);
      -moz-filter: grayscale(100%);
      -ms-filter: grayscale(100%);
      -o-filter: grayscale(100%);
      filter: grayscale(100%);
      filter: gray;
    }

    background: rgba(0, 9, 11, 0.7);
    border: 1px solid rgba(0, 240, 255, 0.4);
    color: #00e5f9;

    i {
      color: #fff;
    }

    &-close {
      position: absolute;
      right: 20px;
      top: 15px;
      cursor: pointer;

      > i {
        font-size: 28px;
        color: #0a4350;
      }
    }
    .tool-bar-wrapper {
      width: 600px;
      height: 60px;
      white-space: nowrap;
      overflow: hidden;
      .carousel-ul {
        height: 60px;
        cursor: pointer;
        display: flex;
        align-items: center;
        .carousel-li {
          width: 120px;
          .text {
            box-sizing: border-box;
            padding: 0px 10px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
      }
      & /deep/ .el-carousel__container{
        height: 60px;
      }

      .el-carousel__button {
        width: 8px;
        height: 8px;
        border-radius: 50%;
      }
      .el-carousel__indicators--outside button{
        background-color: #000;
        opacity: 1;
      }
      .el-carousel__indicator.is-active button{
        background-color: #0a8b9c;
      }
      .el-carousel__indicator--horizontal{
        padding: 6px 4px;
      }
      & /deep/ .el-carousel__arrow--left {
        left: 0;
      }
      & /deep/.el-carousel__arrow--right {
        right: 0;
      }
    }
    &-item {
      align-self: center;
      width: 120px;
      padding: 6px 20px 7px 20px;
      text-align: center;
      cursor: pointer;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;

      &.map-center {
        width: 100px;
        height: 66px;
        padding: 10px 0px;
        position: absolute;
        left: -120px;
        //background: rgba(0,9,11,.7);
        //border: 1px solid rgba(0,240,255,.4);
        border-radius: 50px;
        > i {
          font-size: 24px;
        }
      }
    }
    .anchor-icon {
      width: 22px;
      height: 27px;
      background-size: contain;
    }
  }

  &-add {
    width: 65px;
    height: 65px;
    border-radius: 50%;
    text-align: center;
    line-height: 65px;
    cursor: pointer;
    background: rgba(0, 9, 11, 0.7);
    border: 1px solid rgba(0, 240, 255, 0.5);

    i {
      font-size: 30px;
      color: #2293ac;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mapToolBar/mapToolBar.vue